// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headPortrait .logoname[data-v-73ee5caf]{background:#43a0ff;border-radius:50%;color:#fff;text-align:center;line-height:32px;font-size:18px}", ""]);
// Exports
module.exports = exports;
